import { motion } from "framer-motion";
import { IMAGES } from "@/data";

const tiles = [
  { img: IMAGES.shopFront, alt: "Avanti Pizza & Kebab storefront on Eighth Street", cls: "md:col-span-2 md:row-span-2" },
  { img: IMAGES.pizza, alt: "Close up of a fresh pizza", cls: "" },
  { img: IMAGES.shopInterior, alt: "Inside the shop — counter and menu boards", cls: "" },
  { img: IMAGES.shopSeating, alt: "Outdoor seating along the arcade", cls: "md:col-span-2" },
  { img: IMAGES.shopNight, alt: "The shop lit up at night from the street", cls: "md:col-span-2" },
];

export default function Gallery() {
  return (
    <section id="gallery" className="max-w-7xl mx-auto px-6 py-28 lg:py-40" data-testid="gallery-section">
      <p className="font-mono text-xs tracking-[0.3em] uppercase text-ember mb-4">The Shop</p>
      <h2 className="font-display text-6xl sm:text-7xl leading-none uppercase mb-16 text-gold-shine" data-testid="gallery-heading">
        Straight off<br />the grill
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-4 auto-rows-[220px] gap-4">
        {tiles.map((t, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className={`overflow-hidden border border-zinc-800 group ${t.cls}`}
            data-testid={`gallery-tile-${i + 1}`}
          >
            <img
              src={t.img}
              alt={t.alt}
              loading="lazy"
              className="w-full h-full object-cover grayscale-[30%] group-hover:grayscale-0 group-hover:scale-105 transition-[transform,filter] duration-700"
            />
          </motion.div>
        ))}
      </div>
      <p className="mt-6 font-mono text-xs tracking-[0.2em] uppercase text-zinc-600">
        Photos from the shop — Eighth St, Mildura
      </p>
    </section>
  );
}
